import React, { forwardRef } from "react";
import { MDBDataTableV5 } from "mdbreact";
const DataTablesSupportingDocs = forwardRef((props, ref) => {
	let data = props.data;
	let finalData = [];

	if (data) {
		for (var index = 0; index < data.length; index++) {
			let rowItem = {};
			rowItem["id"] = index+1;
      rowItem["document_name"] =  data[index]?.file_name || 'NA';
			rowItem["owner_name"] = data[index]?.owner_name || 'NA';
			rowItem["file_type"] = data[index]?.file_type || 'NA';
			rowItem["file_view"] = <a href={data[index]?.file_url} target='_blank' rel='noopener noreferrer'><i className='fa fa-file-pdf-o fa-lg'></i></a>;
		  rowItem["status"] = <button className={(data[index]?.status ? "btn custom-btn-outline-info " : " btn btn-outline-danger ")}>{data[index]?.status ? 'Accepted' : 'Pending'}</button>;
      //rowItem["editButton"] = <Link className="btn btn-outline-info" to={`/project/${data[index].id}`}>Edit</Link>;

		  finalData.push(rowItem);
		}
		// console.log("final data", finalData);
	}
	
//const [datatable, setDatatable] = React.useState({
const datatable = {  
  columns: [
      {
        label: 'Document Name',
        field: 'document_name',
        sort: 'disabled',
        width: 150
      },
      {
        label: 'Owner',
        field: 'owner_name',
        sort: 'asc',
        width: 150
      },
      {
        label: 'File Type',
        field: 'file_type',
        sort: 'asc',
        width: 150
      },
      {
        label: 'File View',
        field: 'file_view',
        sort: 'asc',
        width: 150
      },
      // {
      //   label: 'Status',
      //   field: 'status',
      //   width: 150,
      //   sort: 'disabled'
      // } ,
      // {
      //   label: '',
      //   field: 'editButton',
      //   width: 150,
		  //   sort: 'disabled'
      // } 
    ],
    rows: finalData 
	};
  return (
    <MDBDataTableV5 
	   id="mdbDtTable"
        hover
        bordered
        small
        sortable={false}
        striped
        entriesOptions={[5, 10 ,20, 25]} 
        entries={5} 
        pagesAmount={4} 
        data={datatable} 
        searching={false}
        searchBottom={false} 
    />

  );
});

export default DataTablesSupportingDocs;